export const projects_EN = [
    {
      title: "Indicadores E",
      description: "Aplicación que se conecta mediante API REST a una base de datos de indicadores de Chile",
      details: "Desarrollado con ReactJs, Material UI v5, React Router Dom v6 y gráficos Recharts, es una aplicación que muestra un listado de indicadores dispuestos por mindicador.cl, al hacer click en algún indicador del listado, se muestran los detalles de los valores del indicador hace un mes a partir del día de hoy, además de mostrar esta misma información de manera gráfica.",
      github: "https://github.com/oswmoena/crypto-indicadores",
    },
    {
      title: "Gun Hero E",
      description: "Minijuego de navegador",
      details: "Desarrollado con ReactJs, es una aplicación en donde, con una escopeta, hay que derribar a un enemigo que nos acecha en 3 posiciones, mediantes las teclas de flechas para moverse y la tecla Espacio para disparar, se derriba y vuelve más rápido, en donde debemos abatirlo.",
      github: "https://github.com/oswmoena/gun-hero",
    },
    {
      title: "Carrito App E",
      description: "Aplicación de un carrito de compras",
      details: "Desarrollado con ReactJs, es una aplicación de modulo, en donde su unica función es mostrar un carrito de compras, agregando o quitando productos.",
      github: "https://github.com/oswmoena/carrito-app",
    },
    {
      title: "Mantenedor App E",
      description: "Aplicación de un mantenedor de tareas",
      details: "Desarrollado con ReactJs, Material UI v4, Redux, es una aplicación de un mantenedor simple, en donde solo tiene un CRUD de tareas.",
      github: "https://github.com/oswmoena/mantenedor-app",
    },
    {
      title: "Gift Expert E",
      description: "Listado de Gifs de lo que quieras!",
      details: "Desarrollado con ReactJs, es una aplicación en donde se despliega un input text y tenemos que escribir el personaje/serie/pelicula/etc de lo que queramos y mediante Glyphy, nos desplegará 10 GIF.",
      github: "https://github.com/oswmoena/react-gifexpertapp",
    },
  ];
  